const defaults = {
  isLoading: false,
  response: '',
  responseColor: ''
}

export default (state=defaults, action) => {
  switch(action.type) {
    case 'INSERT_MMP_USER_PENDING':
      state = {...state,
        isLoading: true
      };
      break;
    case 'INSERT_MMP_USER_FULFILLED':
      state = {...state,
        isLoading: false,
        response: action.payload.data,
        responseColor: 'green'
      };
      break;
    case 'INSERT_MMP_USER_REJECTED':
      state = {...state,
        isLoading: false,
        response: action.payload.response.data,
        responseColor: 'red'
      };
      break;
    default: // Do nothing
  }

  return state;
};
